export const getQueryParameter = (key) => {
  if (window.location.search) {
    const params = new URLSearchParams(window.location.search)
    return params.get(key)
  }
  return null
}
